import "./style.css";
import { formatGBP } from "../../utils/currency";
type ContainerProps = {
  [x: string]: any;
};

const OutgoingCalcTable = (props: ContainerProps) => {

  return (
    <div className="month-annual-grid">
      <div></div>
      <div className="table-value table-heading">
        <div>Client</div>
        <div>Partner</div>
        <div>Joint</div>
      </div>
      <div className="table-subhead">Monthly</div>
      <div className="table-value">
        <div>{formatGBP(props.OutgoingCalculationValues.MonthlyClientAmount)}</div>
        <div>{formatGBP(props.OutgoingCalculationValues.MonthlyPartnerAmount)}</div>
        <div>{formatGBP(props.OutgoingCalculationValues.MonthlyJointAmount)}</div>
      </div>
      <div className="table-subhead">Annual</div>
      <div className="table-value">
        <div>{formatGBP(props.OutgoingCalculationValues.AnnualClientAmount)}</div>
        <div>{formatGBP(props.OutgoingCalculationValues.AnnualPartnerAmount)}</div>
        <div>{formatGBP(props.OutgoingCalculationValues.AnnualJointAmount)}</div>
      </div>
    </div>
  );
};

export default OutgoingCalcTable;
